
import { Product } from "@/models/base";
import Vue from "vue";
import AppProductGroupSelectAutocomplete from "@/components/product-group/ProductGroupSelectAutocomplete.vue";
import AppProductGroupSelectAutocompleteSimple from "@/components/product-group/ProductGroupSelectAutocompleteSimple.vue";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	data(){
		return {
			value: null as null | number
		};
	},
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	computed: {
		useSimpleGroups():boolean {
			return DossierConfigService.getGeneralConfig().UseSimpleGroups;
		}
	},
	watch: {
		"product.GroupID": {
			immediate: true,
			deep: true,
			handler(){
				this.value = this.product.GroupID;
				//this.value = this.product.Groups.map(g=>g.ProductGroupID)[0] || null;
			}
		},
	},
	methods: {
		onInput(productGroupId:number | null){
			this.product.GroupID = productGroupId;
		}
	},
	components: {
		AppProductGroupSelectAutocomplete,
		AppProductGroupSelectAutocompleteSimple
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
